// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //test
image_url_for_larger: 'https://azapp-citadeladmin-test.azurewebsites.net/images(500X300)/',
 image_url_for_smaller: 'https://azapp-citadeladmin-test.azurewebsites.net/images(300X200)/',
 base_url : 'https://azapp-citadelservice-test.azurewebsites.net',
 test_url:'https://azapp-citadelservice-test.azurewebsites.net',

 // prod
//  image_url_for_larger: 'https://azapp-citadeladmin-prod.azurewebsites.net/images(500X300)/',
//  image_url_for_smaller: 'https://azapp-citadeladmin-prod.azurewebsites.net/images(300X200)/',
//  base_url: 'https://azapp-citadelservice-prod.azurewebsites.net',
//  test_url: 'https://azapp-citadelservice-prod.azurewebsites.net',
 
//sandbox
  square_keys: {
    squareApplicationId: "sandbox-sq0idb-fJvp9V2AnoBI8ZEgOpjRRw",
    squareAccessToken:"EAAAEAC5iuEsBQ1DKr2D-ycbb9jxFZ9CS-bPX9VSH5YLdzs00rFzi9I2V9qyLoKu",
    path: "https://connect.squareupsandbox.com",
    script_path: "https://sandbox.web.squarecdn.com/v1/square.js"
  },

// //production
// square_keys: {
//   squareApplicationId: "sq0idp-rcT83ClqTzLDMAFfdZEyXQ",
//   squareAccessToken: "EAAAEFR5UaitjC1nAikGTfiilGQzz5GilAbl5EgF4EOZOaQRcPDDzTvVRx4FrE38",
//   path: "https://connect.squareup.com",
//   script_path: "https://js.squareup.com/v2/paymentform"
//  },

//sandbox
payment_form:{
  src:"https://sandbox.web.squarecdn.com/v1/square.js" 

},  
//production
// payment_form:{
//   src:"https://js.squareup.com/v2/paymentform" 

//       },

//test
location_id:{
  
  TMC:"L9FC6A5SEF35Z",
  Downtown:"L6EJ5RK23MPSX" 
     
 },
//  //prod
// location_id:{
//   TMC:"L2MDCFHMJX2MB",
//   Downtown:"LDWGWQF27522N"
//  },

timing:{
  Downtown_Bf_Mintime:"08:30",
  Bf_Mintime:"08:00",
  Bf_Maxtime:"10:30",
 
  Lunch_mintime:"10:30",
  //Lunch_maxtime:"20:00"//JSON.parse(localStorage.getItem("current_resturant_timings"))["endLocalTime"],
 
 
     
 },
//production
// square_keys: {
//   squareApplicationId: "sq0idp-rcT83ClqTzLDMAFfdZEyXQ",
//   squareAccessToken: "EAAAEFR5UaitjC1nAikGTfiilGQzz5GilAbl5EgF4EOZOaQRcPDDzTvVRx4FrE38",
//   path: "https://connect.squareup.com",
//   script_path: "https://js.squareup.com/v2/paymentform"
// },
home_page: {
  url: "https://www.citadelbbq.com/"
},
  firebaseConfig : {
    apiKey: "AIzaSyBHpq5Bqmt4fPBne9ykem1OeN49hmEQGb4",
    authDomain: "citadel-hospitality-app.firebaseapp.com",
    databaseURL: "https://citadel-hospitality-app.firebaseio.com",
    projectId: "citadel-hospitality-app",
    storageBucket: "citadel-hospitality-app.appspot.com",
    messagingSenderId: "649570719455",
    appId: "1:649570719455:web:da39ac7f1d710bb7dcbb6a",
    measurementId: "G-7VYXH2W5LT"
  }
 

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
